<template>
    <v-card
            class="mx-auto"
            outlined
            @click="$emit('select')"
    >
        <v-list-item three-line>
            <v-list-item-content>
                <div class="overline mb-4"># {{ member.member_id }}</div>
                <v-list-item-title class="headline mb-4">
                    <v-icon v-if="member.gender==='F'">mdi-gender-female</v-icon>
                    <v-icon v-else-if="member.gender==='M'">mdi-gender-male</v-icon>
                    {{ member.first_name }} {{ member.surname  }}
                </v-list-item-title>
                <v-list-item-subtitle>
                    <div v-if="member.account" class="blue--text mb-1">Account: {{ member.account.user.username }}</div>
                    <div v-if="member.phone_number" class="blue--text mb-1"><a :href="'tel:'+member.phone_number">{{ member.phone_number }}</a></div>

                </v-list-item-subtitle>
            </v-list-item-content>

            <v-list-item-avatar
                    tile
                    size="80"
                    color="grey"

            >
                <img :src="`https://randomuser.me/api/portraits/${ member.gender === 'M' ? 'men' : 'women' }/${member.member_id % 70}.jpg`" />
                <!--<v-img :src="`https://randomuser.me/api/portraits/${ member.gender === 'H' ? 'men' : 'women' }/${member.member_id % 70}.jpg`"></v-img>-->
            </v-list-item-avatar>
        </v-list-item>
        <v-scroll-y-transition>
            <div
                    v-if="active"
                    class="display-3 flex-grow-1 text-center"
            >
                Active
            </div>
        </v-scroll-y-transition>
    </v-card>
</template>
<script>
    export default {
        name: 'MemberCard',
        props: {
            active: {
                type: Boolean,
                value: false
            },
            member: {
                type: Object,
                value: {}
            }
        }
    }
</script>
